<template>
  <div :class="['user-container', { 'sport-organization-user-container': isSportOrganization() }]">
    <p :class="['description', { 'sport-organization-description': isSportOrganization() }]">
      {{ $t('loginToContinue') }}
    </p>
    <div>
      <main-button
        outline
        text="Prijavi se emailom"
        :color="isSportOrganization() ? 'dinamoBlue' : 'black'"
        @click="$emit('login')"
      />
      <main-button flat text="registriraj se" color="#333" @click="$emit('signIn')" />
    </div>
  </div>
</template>

<script>
import { OrganizationType } from '@/types'

export default {
  name: 'login',
  components: {},
  props: {
    organizationType: String,
  },
  data: () => ({}),
  computed: {
    OrganizationType() {
      return OrganizationType
    },
  },
  methods: {
    isSportOrganization() {
      return this.organizationType === OrganizationType.SPORT_ORGANIZATION
    },
  },
}
</script>

<style scoped>
.user-container {
  display: flex;
  width: 100%;
  padding: 32px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  border-top: 2px solid #333;
  background: #f5f5f5;
}

.sport-organization-user-container {
  border-radius: 4px;
  border: 1px solid #0054a5;
  background: rgba(0, 130, 255, 0.1);
}

.description {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  margin-bottom: 0;
  font-style: normal;
  font-weight: 550;
  letter-spacing: -0.6px;
}

.sport-organization-description {
  font-family: Raleway;
  font-weight: 600;
  line-height: 120%;
}
</style>
